<template>
  <master-main
    :addProperties="{ eventType: 1, routeToCreate: getModuleRoute }"
    :dataBadges="[
      {
        columnLabel: $t('common_words.associated_companies2'),
        data: 'businesses',
        property: 'name',
        minWidth: 160,
      },
      {
        columnLabel: $t('common_words.farm'),
        data: 'farms',
        property: 'name',
        minWidth: 160,
      },
    ]"
    :route="getModuleRoute"
    :tableProperties="tableProperties"
    :showExportTables="false"
    @refresh="refresh"
    @showHideLoading="showHideLoading"
    @showNotification="notifyVue"
  />
</template>

<script>
import { getDateToday } from 'src/util/Util';
import BedsTable from './beds-table';
import MasterMain from 'src/components/Layouts/Masters/MasterMain.vue';
import MixinRerender from 'src/mixins/mixin-rerender';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMain from 'src/mixins/master/mixin-main';
import MixinPermissions from 'src/util/mixinPermissions';

export default {
  components: { MasterMain },
  mixins: [
    MixinAlert,
    MixinLoading,
    MixinMain,
    MixinPermissions,
    MixinRerender,
  ],
  data() {
    return { tableProperties: {}, showProperties: { size: '70%' } };
  },
  computed: {
    getModuleRoute() {
      return 'sowing/beds';
    },
    dateToday() {
      return getDateToday();
    },
    buildTableProperties() {
      return {
        tableColumns: [...BedsTable().tableColumns],
        model: 'beds',
        effectTags: 'dark',
        defaultSort: { prop: 'order', order: 'ascending' },
      };
    },
  },
};
</script>
